/**
 * One role model for the Customers UI (C2; ROLLOUT-CUSTOMERS-SHELL.md §4.5): senior_manager is a
 * manager, as the server's CustomerOwnershipService has it since C1a (canEdit and its overrides,
 * canReassign, the manager-can't-steal rule) and C-GATES' delete set.
 *
 * Client role sets MIRROR the server, endpoint by endpoint; they never widen it. Since C2b every
 * server gate that named manager reads backend/utils/customerRoles.js (admin, senior_manager,
 * manager), the ownership audit included, so the audit set is that one too (C4b).
 */

/** admin, senior_manager, manager: delete (C-GATES), assign / reassign (C1a), the unassigned view. */
export const CUSTOMER_MANAGER_ROLES = ['admin', 'senior_manager', 'manager'];

/** GET /:id/ownership-audit: the server's strict role set since C2b (senior_manager admitted). */
export const CUSTOMER_AUDIT_ROLES = ['admin', 'senior_manager', 'manager'];

/** Whether the user holds one of the roles (users.role, or the RBAC role name; any case). */
export const hasCustomerRole = (user, roles) => [user?.role, user?.roleName]
  .filter(Boolean)
  .some((r) => roles.includes(String(r).toLowerCase()));

export const isCustomerManager = (user) => hasCustomerRole(user, CUSTOMER_MANAGER_ROLES);
